import React from 'react';

import Grid from '@mui/material/Grid2';

import { 
  ModelBase, 
  PlayerObject,
  UpsertableBase
} from "@models";
import { 
  CharacterItem, 
  CharacterSpell, 
  PseudoItem, 
  SummonOption2 
} from "@dndModels";

import DandDCharacterUtilities from '@dndUtilities/char_utilities';
import DandDAPI from '@dndUtilities/system_api';

interface Props {
  obj: UpsertableBase | CharacterSpell | CharacterItem | PseudoItem | SummonOption2;
  display_variant?: boolean;
  display_sb?: boolean;
  disabled?: boolean;
  link_url?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement> | undefined) => void;
}

const char_util = DandDCharacterUtilities.getInstance();
const api = DandDAPI.getInstance();

export default function DisplayObject({
  obj,
  display_variant = false,
  display_sb = false,
  disabled = false,
  link_url = "",
  onClick,
}: Props) {

  const detail_format = obj instanceof ModelBase || obj instanceof PlayerObject ? obj.detailFormat() : "";
  
  const detail = char_util.getStringWithReplacementsWithObject({ clean_me: detail_format, backup: "", obj });
  const sbs = display_sb && obj instanceof ModelBase ? api.source_books.filter(o => obj.source_book_ids.includes(o._id)) : [];

  let name = display_variant && obj instanceof ModelBase ? obj.true_name : (obj instanceof PlayerObject || obj instanceof CharacterItem || obj instanceof CharacterSpell ? obj.use_name : obj.name);
  if (name.length === 0) {
    name = "Nameless";
  }
  const renderContent = () => {
    return (
      <Grid container spacing={0} direction="row">
        <Grid size={12}>
          { name }
        </Grid>
        <Grid size={12} className="small_label gray">
          { detail }
        </Grid>
        { display_sb && 
          <Grid size={12} className="small_label gray">
            { sbs.map(o => o.name).join(", ") }
          </Grid>
        }
      </Grid>
    );
  }
  if (link_url) {
    return (
      <a href={link_url} style={{ textDecoration: "none", color: "inherit" }}
        onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.button === 1) {
            return;
          }
          event.preventDefault();
          if (!disabled && onClick) {
            onClick(event);
          }
          return false;
        }}>
        { renderContent() }
      </a>
    );
  } else {
    return (
      <div className={ onClick ? "clickable" : "" }
        onClick={(event: React.MouseEvent<HTMLDivElement>) => {
          if (!disabled && onClick) {
            onClick(event);
          }
        }}>
        { renderContent() }
      </div>
    );
  }
}
